// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nzc0","tabsBox":"styles_tabsBox__2mdHX","createButton":"styles_createButton__WkEir"};